import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { defaultsToPx } from "../../../../utils/catalogUtils";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var OffsetContainer = function OffsetContainer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    offset = _ref.offset,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? '' : _ref$position;
  return /*#__PURE__*/React.createElement("div", {
    className: cn.apply(void 0, ['component'].concat(_toConsumableArray(position.split(' ')), [className])),
    style: offset && {
      transform: "translate(".concat(offset.map(defaultsToPx), ")")
    },
    "data-t-id": "components-OffsetContainer"
  }, children);
};
OffsetContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: PropTypes.string,
  offset: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left', 'top left', 'top right', 'bottom right', 'bottom left'])
} : {};